// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AO2g","question":"styles_question__uYiww","description":"styles_description__3S2Q2"};